<?xml version="1.0" encoding="UTF-8"?>
<svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>4BBB9746-AFF3-4173-8051-08197CA45A30</title>
    <g id="onboarding---desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="D/status-loaded" transform="translate(-532.000000, -531.000000)">
            <g id="progress-bar-+-button-2" transform="translate(288.000000, 70.000000)">
                <g id="radio-button-question-copy-2" transform="translate(224.500000, 441.000000)">
                    <g id="circle-check" transform="translate(19.500000, 20.000000)">
                        <circle id="Oval" fill="#0A9AFF" cx="20" cy="20" r="20"></circle>
                        <polygon id="Path" fill="#FFFFFF" fill-rule="nonzero" points="28.9008212 14 16.6456096 25.9014529 11.111813 20.4434618 10 21.567909 16.6456096 28.1124447 30 15.1370815"></polygon>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>